import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { QUESTION_REGISTRY, SCHEMA_VERSION } from '@bignest/bylaws-kit';
import type { UISchemaSection } from 'projects/bylaws-kit/src/lib/ui-schema';

@Injectable({ providedIn: 'root' })
export class UISchemaService {
  private readonly http = inject(HttpClient);
  private readonly url = '/assets/bylaws/ui/bylaws-schema.v1.json';

  async load(): Promise<{
    sections: UISchemaSection[];
    meta: { uiSchemaVersion: string; registryVersion: string };
  }> {
    const json = await firstValueFrom(this.http.get<any>(this.url));
    const sections: UISchemaSection[] = json.sections ?? json;
    const meta = {
      uiSchemaVersion: json?._meta?.uiSchemaVersion ?? 'unknown',
      registryVersion: json?._meta?.registryVersion ?? 'unknown',
    };
    this.validateAgainstRegistry(sections, meta.registryVersion);
    return { sections, meta };
  }

  private validateAgainstRegistry(
    sections: UISchemaSection[],
    registryVersion: string,
  ): void {
    const reg = new Map(QUESTION_REGISTRY.map((question) => [question.id, question]));
    const uiKeys = new Set<string>();

    for (const section of sections) {
      for (const question of section.questions) {
        uiKeys.add(question.key);
        if (!reg.has(question.key)) {
          console.warn(
            `[UI Schema] key "${question.key}" not found in QUESTION_REGISTRY`,
          );
        }
      }
    }

    for (const id of reg.keys()) {
      if (!uiKeys.has(id)) {
        console.warn(
          `[UI Schema] registry id "${id}" missing from UI layout (will be hidden)`,
        );
      }
    }

    if (registryVersion && registryVersion !== SCHEMA_VERSION) {
      console.warn(
        `[UI Schema] registryVersion ${registryVersion} does not match SCHEMA_VERSION ${SCHEMA_VERSION}`,
      );
    }
  }
}
